import React from 'react'
import { AnimatedLogo, Typography, createStyles, withStyles } from '@paintscout/ui'
import type { WithStyles, MuiTheme as Theme } from '@paintscout/ui'

export interface AppLoadingProps extends WithStyles<typeof styles> {}

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: '75vh',
      color: '#757575',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    spinner: {
      marginBottom: 40
    },
    loading: {
      marginTop: 10,
      color: theme.paintscout.palette.brand.Neutral.P30
    }
  })

function AppLoading(props: AppLoadingProps) {
  return (
    <div className={props.classes.root} data-testid="app-loading">
      <AnimatedLogo scale={0.21} />
      <Typography variant="overline" classes={{ root: props.classes.loading }}>
        &nbsp;&nbsp;Loading...
      </Typography>
    </div>
  )
}
export default withStyles(styles)(AppLoading)
